export default __webpack_public_path__ + "static/media/three.f14c8d9e.jpg";